// extracted by mini-css-extract-plugin
export var quoteAttribution = "quote-module--quoteAttribution--30615";
export var quoteFigure = "quote-module--quoteFigure--f0391";
export var quoteText = "quote-module--quoteText--cedc2";